export default __webpack_public_path__ + "static/media/yoga_and_meditation.3fe55ef5.jpg";